import { useTranslation } from 'react-i18next'

interface GroceryProgressProps {
  total: number
  ticked: number
}

export function GroceryProgress({ total, ticked }: GroceryProgressProps) {
  const { t } = useTranslation('grocery-list')

  if (total === 0) return null

  const percentage = Math.round((ticked / total) * 100)
  const allDone = ticked === total

  return (
    <div className="print:hidden">
      <div
        role="progressbar"
        aria-valuenow={ticked}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-label={t('progress.items', { ticked, total })}
        className="h-1.5 w-full rounded-full bg-gray-200 overflow-hidden"
      >
        <div
          className="h-full rounded-full bg-accent transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <p className="text-xs text-muted mt-1">
        {allDone ? t('progress.allDone') : t('progress.items', { ticked, total })}
      </p>
    </div>
  )
}
